export { default } from './Slide';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Slide/index.js
// module id = 412
// module chunks = 2